/**
 * Shutterfly FE Bridge
 * @license Copyright Shutterfly, Inc. 2017 - all rights reserved
 * Originator: Shawn Rapp
 * Description: Provides a universal event system and communication link
 * between frontend frameworks.
 */

 import "custom-event-polyfill";
 import "./polyfills/NodeList_forEach";
 import "es5-shim";
 import "es6-shim";

 /*----------------------------------------------------------------------------
  Common Classes
 ----------------------------------------------------------------------------*/
 import { EventHandler } from "./lib/EventHandler";

 /*----------------------------------------------------------------------------
   Bootstrap global module
 ----------------------------------------------------------------------------*/
 import "./lib/Global";

 /*----------------------------------------------------------------------------
   Load Adobe Plugin Code
 ----------------------------------------------------------------------------*/
 import "./plugins/AdobeAnalytics/index";
 window.$sflyBridge.ready = true;

 const startEvent = new EventHandler(document);
 startEvent.dispatch("sfly-bridge:loaded", {});

 import "./plugins/Auth/index";
